import Api from "../api/api";

export default async (id) => {
  const { data } = await Api.post(`message/delete/${id}`);
  return data;
};
